import { AdAccountElement } from '../../apis/graphql/accountManagement/adAccount/useFetchAdAccounts';

export const adAccountElement: AdAccountElement[] = [
  {
    id: 'ad-account-id-1',
    name: 'Ad Account 1',
    status: 'ACTIVE',
  },
  {
    id: 'ad-account-id-2',
    name: 'Ad Account 2',
    status: 'ACTIVE',
  },
  {
    id: 'ad-account-id-3',
    name: 'Ad Account 3',
    status: 'ACTIVE',
  },
];

export const adAccount = {
  id: 'b26c5699-8827-463f-aee1-a39d4fb5e212',
  name: 'David Chen Lumber Ad Account',
  status: 'ACTIVE',
  createdAt: '04/11/2024',
  lastLoginAt: '09/19/2024',
  billingContact: {
    id: '220ba828-ab78-4ea1-b7fb-98c02993f584',
    firstName: 'David',
    lastName: 'Chen',
    email: 'dcdis102+ge_bruno_user1@gmail.com',
    __typename: 'BillingContact',
  },
  brand: {
    id: '001KQ0000038KXfYAM',
    name: 'David Chen Lumber',
    industry: {
      id: '0eb098ef-c100-48a9-8dc1-98a2c9a638fa',
      name: 'Home Improvement Products',
      __typename: 'Industry',
    },
    __typename: 'Brand',
  },
  assignedUsers: [
    {
      firstName: 'John',
      lastName: 'Doe',
      id: 'c003367b-74af-4e93-bf28-229b2ae17e69',
      adAccountScopedAssignmentName: 'BUYER',
      __typename: 'User',
    },
  ],
  paymentMethod: {
    paymentMethodExternalId: 'd0663138-0cd5-40b8-b98b-e33d4ee6a4f4',
    paymentMethodName: "David Chen's Amex One",
    lastFour: '0002',
    brand: 'American Express',
    __typename: 'PaymentMethod',
  },
  fundingSource: 'CREDIT_CARD',
  accountsApprovedForTerms: false,
  campaignsCountStatistic: null,
  billableAdServer: '1P',
  invoiceByCampaign: false,
  isMatureBrand: false,
  __typename: 'AdAccount',
};
